<template>
  <div>
    <b-container>
    <div class="wrapper box-shadow">
      <b-row class="align-items-center img-panel">
      </b-row>
      <b-row>
        <b-col>
          <p>{{message}}</p>
        </b-col>
      </b-row>
    </div>
  </b-container>
  </div>
</template>

<script>
export default {
  name: 'SocialRedirect',
  data () {
    return {
      message: 'Redirecting to share content...'
    }
  },
  created () {
    let error = this.$route.query.error
    if(error) {
      this.message = error
      return
    }

    let token = this.$route.query.token
    if(!token) {
      this.message = "Token not found, please try again."
      return
    }
    let socialType = this.$route.params.socialType
    let cookieName = 's-token-' + socialType
    this.$cookie.set(cookieName, token, {expires: '30m'})

    let redirectURL = this.$cookie.get('redirectURL')
    if(!redirectURL) {
      this.message = "Redirect URL not found, please try again."
      return
    }

    this.$cookie.delete('redirectURL')
    window.location.href = redirectURL
  }
}
</script>
